import React from 'react'
import Button from 'cwp-components/base/forms/Button'

const Contact = () => {
  return (
    <div className='w-full my-36'>
      <div className='px-2.5 sm:px-4 md:p-6 lg:px-10 xl:px-16 2xl:px-20 box-border py-5'>
        <div className='w-full max-w-[260px] mx-auto'>
          <p className='text-lg font-medium md:font-bold leading-6 tracking-wide text-center text-[#25395C] mb-4 '>
            Seeking legal help? <br />
            Find an expert lawyer today.
          </p>
          <Button className='btn-primary block mx-auto '> Find</Button>
        </div>
      </div>
    </div>
  )
}
export default Contact
